module.exports = __webpack_public_path__ + "img/zip.cc7eaac6.svg";